/**
 * Scroll to Top Button
 * 
 * Handles the visibility and click functionality of the "Scroll to Top" button.
 * Integrates with Lenis for smooth scrolling if available.
 */

let scrollListener = null;

/**
 * Initializes the Scroll to Top button.
 * @param {object} lenis - Optional Lenis instance for smooth scrolling.
 */
export function initializeScrollToTop(lenis = null) {
    const button = document.getElementById('js-scroll-to-top');
    if (!button) return;

    // Show/hide button based on scroll position
    const checkScroll = () => {
        const scrollThreshold = 400;
        const currentScroll = lenis ? lenis.scroll : window.scrollY;

        if (currentScroll > scrollThreshold) {
            button.classList.add('is-visible');
        } else {
            button.classList.remove('is-visible');
        }
    };

    // Click handler
    const handleClick = (e) => {
        e.preventDefault();
        if (lenis) {
            lenis.scrollTo(0);
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    button.addEventListener('click', handleClick);

    // Initial check
    checkScroll();

    // Add scroll listener
    if (lenis) {
        lenis.on('scroll', checkScroll);
        scrollListener = checkScroll; // Store for cleanup if needed
    } else {
        window.addEventListener('scroll', checkScroll, { passive: true });
        scrollListener = checkScroll;
    }

    // Store references for cleanup
    button._scrollToTopHandler = handleClick;
}

/**
 * Cleans up listeners for the Scroll to Top button.
 * @param {object} lenis - Optional Lenis instance to remove listeners from.
 */
export function destroyScrollToTop(lenis = null) {
    const button = document.getElementById('js-scroll-to-top');
    
    if (scrollListener) {
        if (lenis) {
            lenis.off('scroll', scrollListener);
        } else {
            window.removeEventListener('scroll', scrollListener);
        }
        scrollListener = null;
    }

    if (button && button._scrollToTopHandler) {
        button.removeEventListener('click', button._scrollToTopHandler);
        delete button._scrollToTopHandler;
    }
}